// test328
(328 && 0);
